import { AuthAction, Module, Role, SubModule } from '@/enums';

import { AppRoutes } from './route.constants';

export type PermissionKey = `${Module}.${SubModule}.${AuthAction}`;

export const ROLE_PERMISSIONS: Record<Role, ReadonlyArray<PermissionKey>> = {
  [Role.Unknown]: [],
  [Role.Reviewer]: [
    // Regulatory Intake
    `${Module.RegulatoryIntake}.${SubModule.RegulatoryIntake}.${AuthAction.Create}`,
    `${Module.RegulatoryIntake}.${SubModule.RegulatoryIntake}.${AuthAction.Read}`,
    `${Module.RegulatoryIntake}.${SubModule.RegulatoryIntake}.${AuthAction.Update}`,
  ],
  [Role.SystemAdmin]: [
    // User Management
    `${Module.UserManagement}.${SubModule.UserManagement}.${AuthAction.Create}`,
    `${Module.UserManagement}.${SubModule.UserManagement}.${AuthAction.Read}`,
    `${Module.UserManagement}.${SubModule.UserManagement}.${AuthAction.Update}`,
  ],
};

const REVIEWER_DEFAULT_HOME_PAGE = AppRoutes.INTAKE_JOBS;

const SYSTEM_ADMIN_DEFAULT_HOME_PAGE = AppRoutes.USER_MANAGEMENT;

export const DEFAULT_HOME_PAGE: Record<Role, string> = {
  [Role.Unknown]: SYSTEM_ADMIN_DEFAULT_HOME_PAGE,
  [Role.Reviewer]: REVIEWER_DEFAULT_HOME_PAGE,
  [Role.SystemAdmin]: SYSTEM_ADMIN_DEFAULT_HOME_PAGE,
};
